<mat-accordion>
    <mat-expansion-panel (click)="clearFile('IdentityId')">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="gap-5 flex">
                    ID's 
                <div *ngIf="checkIdentityID === true">
                    <mat-icon color="primary" style="color: green;">check_circle</mat-icon>
                </div></div>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionIdentityId">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'IdentityId')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>

            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="UploadDocument('IdentityId')">Submit</button>
        </div>
        <div *ngIf="dataSource.length > 0 && !uploadSectionIdentityId">
            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="showFileUploadSection('IdentityId')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="overflow: scroll;">

                <!-- Position Column -->
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{loanNumber}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style=" word-break: break-all; white-space: normal; line-height: normal; padding: 8px;"> {{element.documentName}} </td>
                </ng-container>

                <!-- Uploaded By Column -->
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" style="width: 20%;">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'IdentityId')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>
    <mat-expansion-panel (click)="clearFile('FeeAgreement')" (opened)="panelOpenState = true"
        (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="gap-5 flex">
                Fee Agreement from your law firm
                    <div *ngIf="checkFeeAgreement === true">
                    <mat-icon color="primary" style="color: green;">check_circle</mat-icon>
                </div>
                </div>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionFeeAgreement">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'FeeAgreement')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>

                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                    <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon>
                </ngx-dropzone-preview>
            </ngx-dropzone>
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="UploadDocument('FeeAgreement')">Submit</button>
        </div>

        <div *ngIf="dataSource.length > 0 && !uploadSectionFeeAgreement">
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="showFileUploadSection('FeeAgreement')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                <!-- Position Column -->
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{loanNumber}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style=" word-break: break-all; white-space: normal; line-height: normal; padding: 8px;"> {{element.documentName}} </td>
                </ng-container>

                <!-- Uploaded By Column -->
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>


                <!-- Weight Column -->
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>
                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>
                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'FeeAgreement')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>
    <mat-expansion-panel (click)="clearFile('Rent')" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="gap-5 flex">
                3 rent or mortgage statements - 3 Most recent
                    <div *ngIf="checkRent === true">
                    <mat-icon color="primary" style="color: green;">check_circle</mat-icon>
                </div>
                </div>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionRent">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'Rent')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="UploadDocument('Rent')">Submit</button>
        </div>

        <div *ngIf="dataSource.length > 0 && !uploadSectionRent">
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="showFileUploadSection('Rent')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                <!-- Position Column -->
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{loanNumber}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style=" word-break: break-all; white-space: normal; line-height: normal; padding: 8px;"> {{element.documentName}} </td>
                </ng-container>

                <!-- Uploaded By Column -->
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>
                       <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>
                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'Rent')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>
    <mat-expansion-panel (click)="clearFile('UtilityBills')" (opened)="panelOpenState = true"
        (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="gap-5 flex">
                Last 3 Months Utility Bills
                    <div *ngIf="checkUtilityBills === true">
                    <mat-icon color="primary" style="color: green;">check_circle</mat-icon>
                </div>
                </div>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionUtilityBills">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'UtilityBills')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="UploadDocument('UtilityBills')">Submit</button>
        </div>

        <div *ngIf="dataSource.length > 0 && !uploadSectionUtilityBills">
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="showFileUploadSection('UtilityBills')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                <!-- Position Column -->
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{loanNumber}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell  *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style=" word-break: break-all; white-space: normal; line-height: normal; padding: 8px;"> {{element.documentName}} </td>
                </ng-container>

                <!-- Uploaded By Column -->
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>
                       <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>
                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'UtilityBills')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>
    <mat-expansion-panel (click)="clearFile('BankStatement')" (opened)="panelOpenState = true"
        (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="gap-5 flex">
                Last 3 Months Bank Statements
                    <div *ngIf="checkBankStatement === true">
                    <mat-icon color="primary" style="color: green;">check_circle</mat-icon>
                </div>
                </div>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionBankStatement">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'BankStatement')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="UploadDocument('BankStatement')">Submit</button>
        </div>

        <div *ngIf="dataSource.length > 0 && !uploadSectionBankStatement">
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="showFileUploadSection('BankStatement')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                <!-- Position Column -->
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{loanNumber}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell  *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style=" word-break: break-all; white-space: normal; line-height: normal; padding: 8px;"> {{element.documentName}} </td>
                </ng-container>

                <!-- Uploaded By Column -->
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>
                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>
                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'BankStatement')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>
    <mat-expansion-panel (click)="clearFile('PhoneBill')" (opened)="panelOpenState = true"
        (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="gap-5 flex">
                Last 3 Months Phone Bills
                    <div *ngIf="checkPhoneBill === true">
                    <mat-icon color="primary" style="color: green;">check_circle</mat-icon>
                </div>
                </div>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionPhoneBill">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'PhoneBill')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="UploadDocument('PhoneBill')">Submit</button>
        </div>
        <div *ngIf="dataSource.length > 0 && !uploadSectionPhoneBill">
            <button mat-flat-button class="fuse-mat-button-large mt-3" style="margin-left: 0%;" [color]="'primary'"
                (click)="showFileUploadSection('PhoneBill')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                <!-- Position Column -->
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{loanNumber}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell  *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style=" word-break: break-all; white-space: normal; line-height: normal; padding: 8px;"> {{element.documentName}} </td>
                </ng-container>

                <!-- Uploaded By Column -->
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>
                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>
                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'PhoneBill')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </mat-expansion-panel>
</mat-accordion>